import { render, staticRenderFns } from "./OrderLots.vue?vue&type=template&id=e437a234"
import script from "./OrderLots.vue?vue&type=script&lang=js"
export * from "./OrderLots.vue?vue&type=script&lang=js"
import style0 from "./OrderLots.vue?vue&type=style&index=0&id=e437a234&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports